'use client'

import Label from 'labels/components/Label/Label'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { Store } from 'maps/types'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import styles from './Phone.module.scss'

interface PhoneProps {
	readonly store: Store
}

export function Phone({ store }: PhoneProps) {
	const { t } = useLabels()

	return store.details?.phone ? (
		<a
			aria-describedby={`store-${store.id}-description`}
			href={`tel:${store.details.phone}`}
			className={cx(text.bodyM, styles.phone)}
		>
			<Label
				placeholderValues={{
					1: store.details.phone,
				}}
			>
				{t('storeLocator.card.phone.text')}
			</Label>
		</a>
	) : null
}
